AmountInput = {
  "jQuerySelector": 'input.form-control.amount_field.input-mask-amount.mousetrap[text="true"]',
  "html": function(id) {
    return $($.parseHTML('<input></input>'))
      .attr('id', id)
      .addClass('form-control amount_field input-mask-amount mousetrap')
      .attr('text', 'true')
      .wrap('<div class="fg-line"></div>')
      .wrap('<div class="form-group"></div>')
      .prop('outerHTML');
  }
}